import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/forms"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const formsApi = createApi({
    reducerPath: "formsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getForms: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                if (params?.onlyTypes) {
                    tmp.append('only-types', params.onlyTypes.join(','));
                }
                if (params?.popup) {
                    tmp.append('popup', params.popup);
                }
                return `?${tmp.toString()}`
            },
            transformResponse: (response) => response.data,
        }),
        getSingleForm: builder.query({
            query: ({ id, ...params }) => {
                const tmp = new URLSearchParams();
                if (params.movementId) {
                    tmp.append('movement-id', params.movementId);
                }
                return `/${id}/edit?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
        }),
    }),
});

export const {
    useGetSingleFormQuery,
    useLazyGetSingleFormQuery,
    useGetFormsQuery,
    useLazyGetFormsQuery
} = formsApi;
